import { createContext } from "react";

export const ReportInfoEachSectionContext = createContext({
  hasFourColumns: false,
});
